// Services
import notificationService from '@/app/services/main/notification/notification-service.js';
import treatmentService from '@/app/services/main/treatment/treatment-service.js';
import cartService from '@/app/services/main/cart/cart-service.js';
import transactionService from '@/app/services/main/transaction/transaction-service.js';
import ClubsService from '@/app/services/main/club/club-service';

// Constants
import { STATUS_CODES } from '@/app/constants/status-constants';

const notification = {
	state: {
		notificationListDropDown : [],
		notificationListPage : [],
		unreadNotificationCount: 0,
		generalInfo : {
			infoId: null
		},
		treatment: {
			overdueCount: null,
            scheduleData: null
		},
		notficationApiError : {
			message: null,
			res : null
        },
        treatmentAPIError: {
            message: null,
			res : null
		},
		cartApiError: {
			message: null,
			res : null
		},
		cartCount: '',
		pendingOrdersCount: '',
		pendingDogOrdersCount: '',
		groupAdminRequest: {},
		reminder: null,
		purchaseCartCount:'',
		purchaseBundleId:[]
	},
	mutations: {
		setGenInfoId(state, infoId) {
			state.generalInfo.infoId = infoId;
        },
		clearGenInfoId(state) {
			state.generalInfo.infoId = null;
		},
		setUnreadNotificationCount(state, unreadCount) {
			state.unreadNotificationCount = unreadCount;
		},
		setNotificationListDropDown(state, notificationList) {
			state.notificationListDropDown = notificationList;
		},
		setNotificationListPage(state, notificationList) {
			state.notificationListPage = notificationList;
		},
		setTreatmentOverdueCount(state, overdueCount) {
			state.treatment.overdueCount = overdueCount;
		},
		setNotificationApiError(state, apiError) {
			state.notficationApiError = apiError;
        },
        clearTreatmentScheduleData(state) {
            state.treatment.scheduleData = null;
        },
        setTreatmentScheduleData(state, scheduleData) {
            state.treatment.scheduleData = scheduleData;
        },
        setTreatmentAPIError(state, apiError) {
			state.treatmentAPIError = apiError;
		},
		setCartCount(state, cartCount) {
			state.cartCount = cartCount;
		},
		setCartApiError(state, apiError) {
			state.cartApiError = apiError;
		},
		setPendingOrderCount(state, pendingOrdersCount) {
			state.pendingOrdersCount = pendingOrdersCount;
		},
		setPendingDogOrderCount(state, pendingDogOrdersCount) {
			state.pendingDogOrdersCount = pendingDogOrdersCount;
		},
		setTransactionApiError(state, apiError) {
			state.transactionApiError = apiError;
		},
		setGroupAdminRequest(state, groupAdminRequest) {
			state.groupAdminRequest = groupAdminRequest;
		},
		setReminder(state, reminder) {
			state.reminder = reminder;
		},
		clearReminder(state) {
			state.reminder = null;
		},
		setPurchaseCartCount(state, purchaseCartCount) {
			state.purchaseCartCount = purchaseCartCount;
		},
		setPurchaseBundleId(state, purchaseBundleId) {
			state.purchaseBundleId = purchaseBundleId;
		}
	},
	actions: {
		setNotificationList({commit}, {activePetId, queryParams, isPage}) {
			return notificationService.getNotification(activePetId, queryParams)
                .then(res => {
                    if (res.status === STATUS_CODES.SUCCESS) {
						// set notifications to result and determine if page or dropdown
						if (isPage) {
							
							commit('setNotificationListPage', {
								tableData: res.data.data,
								paginationData: res.data.pagination
							});
						} else {
							commit('setNotificationListDropDown', {
								tableData: res.data.data,
								paginationData: res.data.pagination
							});
						}

						commit('setUnreadNotificationCount', res.data.unreadCount);
						
                    } else {
						commit('setNotificationApiError', {
							message: 'Unable to get notification list.',
							res: res
						});
                    }
                });
		},
		setTreatmentOverdueCount({commit, rootState}) {
			const { id: petId } = rootState.lmdcUser.activePet;
			return treatmentService.getTreatmentOverdueCount(petId)
                .then(res => {
                    if (res.status === STATUS_CODES.SUCCESS) {
						// set treatment overdue count to result
						commit('setTreatmentOverdueCount', res.data.dueTreatmentsCount);
                    } else {
						commit('setNotificationApiError', {
							message: 'Unable to get count of overdue treatment.',
							res: res
						});
                    }
                });
		},
        getScheduleData({commit}, treatmentScheduleId) {
	        return treatmentService.getTreatmentSchedule(treatmentScheduleId)
                .then(res => {
                    if (res.status === STATUS_CODES.SUCCESS) {
			            commit('setTreatmentScheduleData', res.data);
                    } else {
                        commit('setTreatmentAPIError', {
							message: 'Unable to get treatment schedule.',
							res: res
						});
                    }
                });
		},
		setCartCount({commit}, petId) {
			const cartDetails = {
				f_type: "products"
			};

			return cartService.getCart(petId, cartDetails)
                .then(res => {
                    if (res.status === STATUS_CODES.SUCCESS) {
						const count = res.data.filter((value) => {
							return !value.subscriptionBundle;
						}).length;

						// set cart count to result
						commit('setCartCount', count);
                    } else {
						commit('setCartApiError', {
							message: 'Unable to get cart count.',
							res: res
						});
                    }
                });
		},
		setPendingOrderCount({commit}, petId) {
			return transactionService.getPendingOrdersCount(petId)
			.then(res => {
				if (res.status === STATUS_CODES.SUCCESS) {
					commit('setPendingOrderCount', res.data.count);
				} else {
					commit('setTransactionApiError', {
						message: 'Unable to get pending orders count.',
						res: res
					});
				}
			});
		},
		setPendingDogOrderCount({commit}) {
			return transactionService.getPendingDogOrdersCount()
			.then(res => {
				if (res.status === STATUS_CODES.SUCCESS) {
					commit('setPendingDogOrderCount', res.data.count);
				} else {
					commit('setTransactionApiError', {
						message: 'Unable to get pending orders count.',
						res: res
					});
				}
			});
		},
		setGroupAdminRequest({commit}) {
			return ClubsService.getGroupAdminRequest()
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						// set treatment overdue count to result
						commit('setGroupAdminRequest', res.data);
					} else {
						commit('setNotificationApiError', {
							message: 'Unable to get group admin request count.',
							res: res
						});
					}
				});
		},
		setPurchaseCartCount({commit}, petId) {

			const cartDetails = {
				f_type: "products"
			};

			return cartService.getCart(petId, cartDetails)
                .then(res => {
                    if (res.status === STATUS_CODES.SUCCESS) {
						// set cart count to result
						commit('setPurchaseCartCount', 100);
                    } else {
						commit('setCartApiError', {
							message: 'Unable to get cart count.',
							res: res
						});
                    }
                });
		},
	},
	getters: {
		getGenInfoId(state) {
			return state.generalInfo.infoId;
		},
		getUnreadNotificationCount(state) {
			return state.unreadNotificationCount;
		},
		getNotificationListDropDown(state) {
			return state.notificationListDropDown;
		},
		getNotificationListPage(state) {
			return state.notificationListPage;
		},
		getOverdueTreatmentCount(state) {
			return state.treatment.overdueCount;
		},
		getNotificationApiError(state) {
			return state.notficationApiError;
        },
        getTreatmentSchedule(state) {
			return state.treatment.scheduleData;
        },
        getTreatmentAPIError(state) {
			return state.treatmentAPIError;
		},
		getCartCount(state) {
			return state.cartCount;
		},
		getCartApiError(state) {
			return state.cartApiError;
		},
		getPendingOrdersCount(state) {
			return state.pendingOrdersCount;
		},
		getPendingDogOrdersCount(state) {
			return state.pendingDogOrdersCount;
		},
		getTransactionApiError(state) {
			return state.transactionApiError;
		},
		getGroupAdminRequests(state) {
			return state.groupAdminRequest;	
		},
		getReminder(state) {
			return state.reminder;
		},
		getPurchaseCartCount(state) {
			return state.purchaseCartCount;
		},
		getPurchaseBundleId(state) {
			return state.purchaseBundleId;
		}
	}
}

export default notification;